<template>
  <b-overlay :show="true" rounded="sm" opacity="0.5" style="position: unset !important;"></b-overlay>
</template>

<script>
import {doAuthorizationLogin} from "@/api";

export default {
  name: 'authRedirect',
  data() {
    return {

    }
  },
  async mounted() {
    console.log(this.$route.query.code)
    this.stuLogin();
  },
  methods: {
    // 学生登录
    async stuLogin() {
      doAuthorizationLogin({code:this.$route.query.code}).then(async (res1) => {
        const res = await this.axios.post("/student/login");
        this.user = res.data
        this.$store.commit("LOGIN", this.user);
        const info = await this.axios.get("/student/info");
        if (info.data.length > 0) {
          this.$store.commit("LOGINBAK", info.data);
          if (info.data && info.data.length > 1) {
            this.$refs.SelectMajor.open((e) => {
              this.goHome(e);
            }, true);
          } else {
            this.goHome(info.data[0]);
          }
        } else {
          this.$router.push({path: "/main/readyExam"});
        }
      }).catch((err) => {
        this.$bvToast.toast("登陆失败，请重试！", {
          title: "提示",
          variant: "danger",
          solid: true,
        });
      });
    },

    async goHome(user) {
      this.user.regInfo = user;
      this.$store.commit("LOGIN", this.user);
      const params = {
        schoolId: user.schoolId,
      };
      const {data} = await this.axios.get("/comm/findSysConfig", {
        params,
      });
      this.$store.commit("SYSCONFIG", data);
      this.$router.push({path: "/main/home"});
    },

  },
}
</script>

<style lang="scss" scoped>

</style>
